module.exports = __webpack_public_path__ + "img/yyjd.f64995c2.jpg";